module.exports = __webpack_public_path__ + "static/sippy_lager-e8a9dc8546b070d073cf71ca76981d7c.jpg";